module.exports = __webpack_public_path__ + "img/BMU.78a3cb98.svg";